import { forwardRef } from "react";
import { SVGFillPath, SVGIconRoot } from "./SVGComponents";
import { IconProps } from "./index";

export const ArrowLeft = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 12 18" ref={ref} {...props}>
      <SVGFillPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1904 15.6096L4.59522 8.99999L11.1904 2.39039L9.16002 0.359985L0.52002 8.99999L9.16002 17.64L11.1904 15.6096Z"
      />
    </SVGIconRoot>
  );
});
